<div *ngIf="!loading">
  <div class="booble-backdrop">
    <div class="xp-modal xp-modal-cadastro">
      <div
        class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm"
      >
        <div class="modal-content">
          <div class="modal-header">
            <div class="header-title">
              <h4 class="m-0 title-modal">Detalhe da Ordem</h4>
              <div class="ml-3 chip">
                <p class="m-0 order-type">
                  {{ rType == "0" ? "Receber dinheiro" : "Envio de dinheiro" }}
                </p>
              </div>
            </div>
            <div (click)="closeModal()" class="close-icon tappable">
              <img src="assets/image/close-modal-icon.svg" />
            </div>
          </div>

          <div class="modal-dialog-scrollable-general">
            <app-order-data
              [boobleModalData]="boobleModalData"
              [rType]="rType"
              [commercial]="commercial"
              [ir]="ir"
              [iof]="iof"
              [currency]="currency"
              [showDocuments]="true"
            ></app-order-data>
          </div>

          <ng-container
            *ngIf="
              !this.boobleModalData?.quotations[0] &&
              this.boobleModalData?.statusFlow != 'PAID' &&
              this.boobleModalData?.statusFlow != 'CANCELED' &&
              this.boobleModalData?.statusFlow != 'PROCESSING' &&
              this.boobleModalData?.orderSource != 'EXCHANGE'
            "
          >
            <div class="buttons-end">
              <button
                class="btn mb-3 btn-dark-primary-red"
                (click)="cancelOrder(this.boobleModalData)"
                type="button"
              >
                Cancelar
                <span
                  class="spinner-border spinner-border-sm"
                  *ngIf="loading"
                ></span>
              </button>
            </div>
          </ng-container>

          <ng-container
            *ngIf="
              (!this.boobleModalData?.orderSettlement?.exchangeContractFile ||
                !this.boobleModalData?.orderSettlement?.proofOperationFile ||
                this.boobleModalData?.orderSettlement
                  ?.orderSettlementAttachments?.length == 0) &&
              this.boobleModalData?.orderSource == 'EXCHANGE'
            "
          >
            <div class="buttons-end">
              <button
                type="button"
                class="btn-footer btn btn-dark-primary-blue"
                type="button"
                (click)="
                  openSettlementDocumentsComponentModal(
                    this.boobleModalData?.id
                  )
                "
              >
                Anexar comprovantes
              </button>
            </div>
          </ng-container>

          <ng-container
            *ngIf="
              !this.boobleModalData?.quotations[0] &&
              this.boobleModalData?.statusFlow == 'PROCESSING'
            "
          >
            <div class="buttons">
              <button
                class="btn mb-3 btn-dark-primary-red"
                (click)="cancelOrder(this.boobleModalData)"
                type="button"
              >
                Cancelar
                <span
                  class="spinner-border spinner-border-sm"
                  *ngIf="loading"
                ></span>
              </button>

              <button
                type="button"
                class="btn-footer btn btn-dark-primary-blue"
                type="button"
                (click)="openOrderReviewModal(this.boobleModalData?.id)"
              >
                Analisar ordem
              </button>
            </div>
          </ng-container>

          <ng-container
            *ngIf="
              this.boobleModalData?.quotations[0] &&
              (this.boobleModalData?.statusFlow ==
                'PENDING_PAYMENT_INFORMATION' ||
                this.boobleModalData?.statusFlow == 'PENDING_ORDER_INFORMATION')
            "
          >
            <div class="buttons">
              <button
                class="stroked-red"
                (click)="cancelOrder(this.boobleModalData)"
                mat-stroked-button
              >
                Cancelar
              </button>

              <button
                class="btn mb-3 btn-dark-primary-red"
                (click)="cancelQuotation()"
                type="button"
              >
                Cancelar a cotação
                <span
                  class="spinner-border spinner-border-sm"
                  *ngIf="loading"
                ></span>
              </button>
            </div>
          </ng-container>

          <ng-container
            *ngIf="
              this.boobleModalData?.quotations[0] &&
              this.boobleModalData?.statusFlow == 'PAYMENT_REPROVED'
            "
          >
            <div class="buttons">
              <button
                class="stroked-red"
                (click)="cancelOrder(this.boobleModalData)"
                mat-stroked-button
              >
                Cancelar
              </button>

              <button
                *ngIf=""
                type="button"
                class="btn-footer btn btn-dark-primary-blue"
                type="button"
                (click)="openPaymentConfirmApprovedModal(this.boobleModalData)"
              >
                Pendência concluída
              </button>
            </div>
          </ng-container>

          <ng-container
            *ngIf="
              this.boobleModalData?.quotations[0] &&
              (this.boobleModalData?.statusFlow == 'AVAILABLE_PAYMENT' ||
                this.boobleModalData?.statusFlow == 'IDENTIFYING_PAYMENT')
            "
          >
            <div class="buttons">
              <button
                class="btn mb-3 btn-dark-primary-red"
                (click)="cancelOrder(this.boobleModalData)"
                type="button"
              >
                Cancelar
                <span
                  class="spinner-border spinner-border-sm"
                  *ngIf="loading"
                ></span>
              </button>

              <button
                *ngIf="
                  (this.boobleModalData?.statusFlow == 'AVAILABLE_PAYMENT' ||
                    this.boobleModalData?.statusFlow ==
                      'IDENTIFYING_PAYMENT') &&
                  this.boobleModalData?.confirmationTreasury &&
                  this.boobleModalData?.confirmationSlip &&
                  this.boobleModalData?.effected &&
                  this.boobleModalData?.remmitanceType == 'OUTBOUND'
                "
                type="button"
                class="btn-footer btn btn-dark-primary-blue"
                type="button"
                title="Confirmar pagamento"
                (click)="openPaymentConfirmModal(this.boobleModalData?.id)"
              >
                Confirmar pagamento
              </button>
              <button
                *ngIf="
                  (this.boobleModalData?.statusFlow == 'AVAILABLE_PAYMENT' ||
                    this.boobleModalData?.statusFlow ==
                      'IDENTIFYING_PAYMENT') &&
                  this.boobleModalData?.confirmationTreasury &&
                  this.boobleModalData?.confirmationSlip &&
                  !this.boobleModalData?.effected &&
                  this.boobleModalData?.remmitanceType == 'OUTBOUND'
                "
                type="button"
                class="btn-footer btn btn-dark-primary-blue"
                type="button"
                title="Confirmar efetivação"
                (click)="openExecutionOrderModal(this.boobleModalData?.id)"
              >
                Confirmar efetivação
              </button>
              <button
                *ngIf="
                  (this.boobleModalData?.statusFlow == 'AVAILABLE_PAYMENT' ||
                    this.boobleModalData?.statusFlow ==
                      'IDENTIFYING_PAYMENT') &&
                  this.boobleModalData?.confirmationTreasury &&
                  !this.boobleModalData?.confirmationSlip &&
                  this.boobleModalData?.remmitanceType == 'OUTBOUND'
                "
                title="Informações para boletar no Exchange"
                type="button"
                class="btn-footer btn btn-dark-primary-blue"
                type="button"
                (click)="openExchangeInfoModal(this.boobleModalData?.id)"
              >
                Boletar
              </button>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
